import { Component } from '@angular/core';

@Component({
  selector: 'app-dummy',
  template: ''
})
export class DummyComponent{

  constructor() { }


}
